import { CircularProgress, RaisedButton } from "material-ui";
import * as TimeUtils from "../../../../general/time-utils";

const React = require("react");

export default class UserApprovalRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true
    };
  }

  render() {
    let state = "Aprobat";
    if (!this.props.allApproved) {
      if (this.props.approved === undefined || this.props.approved === null) {
        state = "";
      } else if (!this.props.approved) {
        state = "Respins";
      }
    }

    return (
      <tr>
        <td>
          <div
            style={{
              maxWidth: "150px",
              wordWrap: "break-word"
            }}
          >
            {this.props.calling}
          </div>
        </td>
        <td>{this.props.firstName}</td>
        <td>{this.props.lastName}</td>
        <td>{this.props.email}</td>
        <td>
          {state === "" && this.props.canApprove ? (
            <div>
              {this.props.showApprovingProgress && (
                <div style={{ display: "inline", marginRight: "10px" }}>
                  <CircularProgress />
                </div>
              )}
              <div style={{ display: "inline" }}>
                <RaisedButton
                  disabled={this.props.showApprovingProgress}
                  primary
                  label={"Aproba"}
                  onClick={() =>
                    this.props.onApprove(
                      this.props.paper,
                      this.props.orderNumber
                    )
                  }
                />
                <RaisedButton
                  disabled={this.props.showApprovingProgress}
                  style={{ marginLeft: "20px" }}
                  secondary
                  label={"Respinge"}
                  onClick={() =>
                    this.props.onReject(
                      this.props.paper,
                      this.props.orderNumber
                    )
                  }
                />
              </div>
            </div>
          ) : (
            state
          )}
        </td>
        <td>{this.props.date && TimeUtils.getAprovalDateFormat(this.props.date)}</td>
      </tr>
    );
  }
}
